
import Vue from "vue";
import WaitBase from "./partials/WaitBase.vue";

export default Vue.extend({
  components: { WaitBase },
});
